import axios from "axios";
   
async function AuthProvider() {
  let isloggedin = false;
  
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  axios.defaults.withCredentials = true;

  await axios.post(BACKEND_URL + '/checkLoggedIn')
  .then(res => { 
    isloggedin = res.data.isloggedin;
  })
  .catch(err => { window.location="/"; });

  return isloggedin;
};

export default AuthProvider